  <template>
  <div>
    <activity-redirect-item
        :loan-tasks="tasks"
        :current-loan-task="currentTaskName"
        :is-loan-task="true"
        :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <address-stage-provider
    :propShowSameAsCurrentAddressCheckbox="true"
    :addressType="addressType"
    :tasks="tasks"
    :currentTaskName="currentTaskName"
    ></address-stage-provider>
  </div>
</template>

<script>

import LoanScopeDataHolder from "@/data/model/LoanScopeDataHolder";

import ActivityRedirectItem from "../layout/ActivityRedirectItem";
import {Activities} from "@/utils/ActivityNavigator";
import AddressStageProvider
  from "@/components/providers/AddressStageProvider";
import AddressResponse from '../../data/model/AddressResponse';

export default {
  name: "AddressActivity",
  components: {ActivityRedirectItem, AddressStageProvider},

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.PERMANENT_ADDRESS];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
          ? LoanScopeDataHolder.getCurrentLoanTask().name : "";
    },

    addressType() {
      return AddressResponse.PERMANENT_ADDRESS_TYPE;
    }
  }
}
</script>

<style scoped></style>
 
 <!-- 
<template>
  <div>
    <tool-bar :title="title"></tool-bar>
    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false">
    </error-alert-item>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <stage-comment-item></stage-comment-item>

    <refresh-item
      :show="showRefreshItem"
      @onRefresh="fetchInitialData"
    ></refresh-item>

    <div class="margin_top_20" v-show="showUI">
      <div class="item-heading-desc-div margin-left-10 margin-right-10">
        <weex-text class="item-heading">{{addressHeading}}</weex-text>
      </div>

      <wxc-checkbox
        v-show="showSameAsCurrentAddressCheckbox"
        class="margin-left-10 margin-right-10"
        v-for="item in sameAsCurrentAddressCheckboxList"
        :key="item"
        :config="checkBoxConfig"
        :checked="sameAsCurrentAddressDefaultSelection"
        :title="item"
        :value="item"
        @wxcCheckBoxItemChecked="onSameAsCurrentAddressCheckboxClicked"
      ></wxc-checkbox>

      <div class="input_container margin_top_40">
        <weex-text class="input_label">Flat/HouseNo./Floor/Building</weex-text>
        <input
          class="input_with_border_bottom"
          :value="getFieldValue('street')"
          @input="inputEntered('street', $event.target.value)"
          return-key-type="next">
      </div>

      <div class="input_container">
        <weex-text class="input_label">Colony/Street/Locality</weex-text>
        <input
          class="input_with_border_bottom"
          :value="getFieldValue('addressLine1')"
          @input="inputEntered('addressLine1', $event.target.value)"
          return-key-type="next">
      </div>

      <div class="input_container">
        <weex-text class="input_label">Landmark</weex-text>
        <weex-text class="input_label_des">(Optional)</weex-text>
        <input
          class="input_with_border_bottom"
          :value="getFieldValue('addressLine2')"
          @input="inputEntered('addressLine2', $event.target.value)"
          return-key-type="next">
      </div>

      <div class="input_container">
        <weex-text class="input_label">Pin Code</weex-text>
        <input
          class="input_with_border_bottom"
          :value="getFieldValue('postalCode')"
          @input="postalEntered($event.target.value)"
          type="number"
          maxlength="6"
          return-key-type="next">
      </div>

      <div class="dropdown_container">
        <wxc-dropdown
          title="State"
          default-item="Select"
          :config="dropdownConfig"
          :disabled="stateDropdownDisabled"
          :select-item="selectState"
          :list="stateList"
          @onItemSelected="onStateSelected"
        ></wxc-dropdown>
      </div>

      <div class="input_container">
        <weex-text class="input_label">District</weex-text>
        <input
          :readonly="disableAddressLine3"
          class="input_with_border_bottom"
          :value="getFieldValue('addressLine3')"
          @input="inputEntered('addressLine3', $event.target.value)"
          return-key-type="next">
      </div>

      <div class="input_container">
        <weex-text class="input_label">City</weex-text>
        <input
          :readonly="disableCity"
          class="input_with_border_bottom"
          :value="getFieldValue('city')"
          @input="inputEntered('city', $event.target.value)"
          return-key-type="done">
      </div>

      <div class="item-row-alignment margin_top_20">
        <div
          style="width: 50%; margin: 0 5px 0 10px"
          v-if="isFieldNeeded('permanent_address_years')">
          <weex-text class="input_label">{{getFieldLabel('permanent_address_years')}}</weex-text>
          <input
            class="input_with_border_bottom"
            :value="getDynamicFieldValue('permanent_address_years')"
            @input="onDynamicFieldEntered('permanent_address_years', $event.target.value)"
            return-key-type="next">
          <field-error-item
            :show-error="showFieldError('permanent_address_years')"
            :error-msg="getErrorMsg('permanent_address_years')"
          ></field-error-item>
        </div>

        <div style="width: 50%; margin: 0 10px 0 5px"
             v-if="isFieldNeeded('permanent_address_months')">
          <weex-text class="input_label">{{getFieldLabel('permanent_address_months')}}</weex-text>
          <input
            class="input_with_border_bottom"
            :value="getDynamicFieldValue('permanent_address_months')"
            @input="onDynamicFieldEntered('permanent_address_months', $event.target.value)"
            return-key-type="next">
          <field-error-item
            :show-error="showFieldError('permanent_address_months')"
            :error-msg="getErrorMsg('permanent_address_months')"
          ></field-error-item>
        </div>
      </div>

      <div class="item-row-alignment margin_top_20">
        <div
          style="width: 50%; margin: 0 5px 0 10px"
          v-if="isFieldNeeded('permanent_city_years')">
          <weex-text class="input_label">{{getFieldLabel('permanent_city_years')}}</weex-text>
          <input
            class="input_with_border_bottom"
            :value="getDynamicFieldValue('permanent_city_years')"
            @input="onDynamicFieldEntered('permanent_city_years', $event.target.value)"
            return-key-type="next">
          <field-error-item
            :show-error="showFieldError('permanent_city_years')"
            :error-msg="getErrorMsg('permanent_city_years')"
          ></field-error-item>
        </div>

        <div style="width: 50%; margin: 0 10px 0 5px"
             v-if="isFieldNeeded('permanent_city_months')">
          <weex-text class="input_label">{{getFieldLabel('permanent_city_months')}}</weex-text>
          <input
            class="input_with_border_bottom"
            :value="getDynamicFieldValue('permanent_city_months')"
            @input="onDynamicFieldEntered('permanent_city_months', $event.target.value)"
            return-key-type="next">
          <field-error-item
            :show-error="showFieldError('permanent_city_months')"
            :error-msg="getErrorMsg('permanent_city_months')"
          ></field-error-item>
        </div>
      </div>

      <wxc-button
        text="Next"
        class="horizontal_center margin_top_40 margin-bottom-20"
        type="blue"
        @wxcButtonClicked="onSubmit"
      ></wxc-button>
    </div>
  </div>
</template>

<script>
import ToolBar from "../layout/ToolBar";
import Loading from "../layout/Loading";
import ActivityRedirectItem from "../layout/ActivityRedirectItem";
import StageCommentItem from "../layout/StageCommentItem";
import ErrorAlertItem from "../layout/ErrorAlertItem";
import WxcButton from "../../../weex-ui/packages/wxc-button";
import WxcDropdown from "../../../weex-ui/packages/wxc-dropdown";
import WxcCheckbox from "../../../weex-ui/packages/wxc-checkbox";
import EzUtils from "../../utils/EzUtils";
import LoanTasksActivityNavigator from "../../utils/LoanTasksActivityNavigator";
import DataTableUtils from "../../utils/DataTableUtils";
import { DefaultResourceConfig } from "../../utils/ImageResourcesUtil";
import { MessageConstants } from "../../utils/MessageConstantUtil";
import { Activities } from "../../utils/ActivityNavigator";
import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
import DataSource from "../../data/DataSource";
import AddressResponse from "../../data/model/AddressResponse";
import AlertService from "../core/alert/AlertService";
import PrefManager from "../../data/model/PrefManager";
import { RolesConstants } from "../../utils/RolesConstants";
import RefreshItem from "../layout/RefreshItem";
import FieldErrorItem from "../layout/FieldErrorItem";
import DynamicFieldUtils from "../../utils/DynamicFieldUtils";
import { DataTables } from "../../utils/DataTables";

const PERMANENT_ADDRESS_TYPE = "permanent";
const HOME_ADDRESS_TYPE = "home";
const INDIA = "India";
const REGEX_YEARS = "^[0-9]{1,2}$";
const REGEX_MONTH = "^(0|0?[1-9]|1[01])$";

const ALL_FIELDS_DATA = {
  permanent_address_years: {
    label: "Years at Address",
    validation: REGEX_YEARS,
    fieldType: "EDIT_FIELD",
    errorMsg: "Enter valid no of Years.",
    optional: false
  },

  permanent_address_months: {
    label: "Months at Address",
    validation: REGEX_MONTH,
    fieldType: "EDIT_FIELD",
    errorMsg: "Allowed value: 0-11",
    optional: false
  },

  permanent_city_years: {
    label: "Years at City",
    validation: REGEX_YEARS,
    fieldType: "EDIT_FIELD",
    errorMsg: "Enter valid no of Years.",
    optional: false
  },

  permanent_city_months: {
    label: "Months at City",
    validation: REGEX_MONTH,
    fieldType: "EDIT_FIELD",
    errorMsg: "Allowed value: 0-11",
    optional: false
  },
};

export default {
  name: "AddressActivity",
  components: {
    ActivityRedirectItem,
    ErrorAlertItem,
    Loading,
    ToolBar,
    WxcButton,
    WxcDropdown,
    WxcCheckbox,
    StageCommentItem,
    RefreshItem,
    FieldErrorItem
  },
  data: () => ({
    title: "Permanent Address",
    address: {
      street: "",
      addressLine1: "",
      addressLine2: "",
      addressLine3: "",
      city: "",
      postalCode: "",
      stateProvinceId: -1,
      addressTypeId: -1,
      countryId: -1
    },
    addressTimeData: {
      permanent_address_years: null,
      permanent_address_months: null,
      permanent_city_years: null,
      permanent_city_months: null
    },
    currentAddress: {},
    showUI: false,
    stateList: [],
    selectState: null,
    disableCity: false,
    disableAddressLine3: false,
    stateDropdownDisabled: false,
    stateProvinceIdOptions: [],
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    showRefreshItem: false,
    permanentAddressTypeId: -1,
    currentAddressTypeId: -1,
    countryId: -1,
    sameAsCurrentAddressCheckboxList: ["Same as Current Address"],
    showSameAsCurrentAddressCheckbox: false,
    sameAsCurrentAddressDefaultSelection: false,
    dynamicFields: null,
    invalidFields: []
  }),
  methods: {
    showToast(message) {
      AlertService.showToast(message);
    },

    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    isFieldNeeded(key) {
      return this.dynamicFields == null || this.dynamicFields[key] != null;
    },

    getFieldLabel(key) {
      return this.dynamicFields && this.dynamicFields[key] && this.dynamicFields[key]['label']
        ? this.dynamicFields[key]["label"]
        : ALL_FIELDS_DATA[key]["label"];
    },

    showFieldError(key) {
      return this.invalidFields && this.invalidFields.includes(key);
    },

    getErrorMsg(key) {
      return ALL_FIELDS_DATA[key]["errorMsg"];
    },

    getFieldValue(key) {
      return this.address && this.address[key] ? this.address[key] : "";
    },

    onDynamicFieldEntered(key, value) {
      this.addressTimeData[key] = value;
      this.removeFromInvalidFieldsIfValid(key);
    },

    getDynamicFieldValue(key) {
      return this.addressTimeData && this.addressTimeData[key] ? this.addressTimeData[key] : "";
    },

    removeFromInvalidFieldsIfValid(key) {
      this.invalidFields = DynamicFieldUtils.removeFromInvalidFieldsIfValidValue(
        this.invalidFields,
        key,
        this.addressTimeData[key],
        ALL_FIELDS_DATA,
        this.dynamicFields
      );
    },

    inputEntered(key, value) {
      this.address[key] = value;
    },

    onStateSelected(e) {
      this.onStateEntered(e.value);
    },

    onStateEntered(state) {
      this.selectState = state;
      this.inputEntered(AddressResponse.STATE_PROVINCE_ID,
        parseInt(DataTableUtils.getOptionId(this.stateProvinceIdOptions, state))
      );
    },

    onSameAsCurrentAddressCheckboxClicked(e) {
      this.resetAddressField();
      if (e.checked) {
        this.fillAddressWithCurrentAddress();
      }
    },

    resetAddressField() {
      this.inputEntered(AddressResponse.STREET, "");
      this.inputEntered(AddressResponse.ADDRESS_LINE1, "");
      this.inputEntered(AddressResponse.ADDRESS_LINE2, "");
      this.inputEntered(AddressResponse.ADDRESS_LINE3, "");
      this.inputEntered(AddressResponse.CITY, "");
      this.inputEntered(AddressResponse.STATE_PROVINCE_ID, -1);
      this.postalEntered("");
    },

    fillAddressWithCurrentAddress() {
      this.inputEntered(AddressResponse.STREET, this.currentAddress[AddressResponse.STREET]);
      this.inputEntered(
        AddressResponse.ADDRESS_LINE1,
        this.currentAddress[AddressResponse.ADDRESS_LINE1]
      );
      this.inputEntered(
        AddressResponse.ADDRESS_LINE2,
        this.currentAddress[AddressResponse.ADDRESS_LINE2]
      );
      this.inputEntered(
        AddressResponse.ADDRESS_LINE3,
        this.currentAddress[AddressResponse.ADDRESS_LINE3]
      );
      this.inputEntered(AddressResponse.CITY, this.currentAddress[AddressResponse.CITY]);
      this.postalEntered(this.currentAddress[AddressResponse.POSTAL_CODE]);
    },

    postalEntered(postalCode) {
      this.inputEntered(AddressResponse.POSTAL_CODE, postalCode);
      this.getPostalCodeDetails();
    },

    getPostalCodeDetails() {
      if (EzUtils.validatePostalCode(this.getFieldValue(AddressResponse.POSTAL_CODE))) {
        this.loading = true;
        DataSource.getPincodeDetails(this.getFieldValue(AddressResponse.POSTAL_CODE))
          .then(postalCodeRes => {
            this.loading = false;
            if (postalCodeRes.errorOccurred) {
              this.selectState = "";
              this.stateDropdownDisabled = false;
              this.disableCity = false;
              this.disableAddressLine3 = false;
            } else {
              const postalCodeData = postalCodeRes.data ? postalCodeRes.data : {};
              if (this.isValidState(postalCodeData.state)) {
                this.selectState = postalCodeData.state;
                this.stateDropdownDisabled = true;
              } else {
                this.stateDropdownDisabled = false;
                this.selectState = "";
              }
              if (postalCodeData.district) {
                this.inputEntered(AddressResponse.ADDRESS_LINE3, postalCodeData.district);
                this.inputEntered(AddressResponse.CITY, postalCodeData.district);
                this.disableCity = true;
                this.disableAddressLine3 = true;
              } else {
                this.disableCity = false;
                this.disableAddressLine3 = false;
              }
            }
          });
      } else {
        this.selectState = "";
        this.stateDropdownDisabled = false;
        this.disableCity = false;
        this.disableAddressLine3 = false;
      }
    },

    isValidState(state) {
      let validState = false;
      this.stateList && this.stateList.forEach(item => {
        if (item && item === state) {
          validState = true;
        }
      });

      return validState;
    },

    onSubmit() {
      if (this.checkForValidation()) {
        this.saveAddress();
      }
    },

    checkForValidation() {
      this.invalidFields = DynamicFieldUtils.validateDynamicFieldsForRequiredFields(
        this.addressTimeData,
        ALL_FIELDS_DATA,
        this.dynamicFields
      );
      if (!this.getFieldValue(AddressResponse.STREET)
        || !this.getFieldValue(AddressResponse.ADDRESS_LINE1)
        || !this.getFieldValue(AddressResponse.ADDRESS_LINE3)
        || !this.getFieldValue(AddressResponse.CITY)
        || !this.getFieldValue(AddressResponse.POSTAL_CODE)
      ) {
        this.showToast(MessageConstants.EMPTY_FIELD_MESSAGE);
        return false;
      }

      if (!this.isValidStreetAddress()) {
        this.showToast(MessageConstants.INVALID_STREET_ADDRESS_MESSAGE);
        return false;
      }

      if (!EzUtils.validatePostalCode(this.getFieldValue(AddressResponse.POSTAL_CODE))) {
        this.showToast(MessageConstants.INVALID_POSTAL_CODE_MESSAGE);
        return false;
      }

      if (!this.getFieldValue(AddressResponse.STATE_PROVINCE_ID)
        || parseInt(this.getFieldValue(AddressResponse.STATE_PROVINCE_ID)) === -1
      ) {
        this.showToast(MessageConstants.SELECT_STATE_MESSAGE);
        return false;
      }

      return !this.invalidFields || this.invalidFields.length === 0;
    },

    isValidStreetAddress() {
      let streetArray = this.getFieldValue(AddressResponse.STREET).trim().split(" ");
      if (streetArray.length < 2) {
        return false;
      }
      let streetItemCount = 0;
      streetArray.forEach(streetSplitValue => {
        streetItemCount = (streetSplitValue.trim().length > 1) ? streetItemCount + 1
          : streetItemCount;
      });

      return streetItemCount > 0;
    },

    saveAddress() {
      const addressPayload = AddressResponse.getAddressPayload(this.address);
      this.loading = true;
      DataSource.saveClientAddress(
        LoanScopeDataHolder.getClientId(),
        this.address[AddressResponse.ADDRESS_TYPE_ID],
        addressPayload
      )
        .then(clientAddressSaveRes => {
          this.loading = false;
          if (clientAddressSaveRes.errorOccurred) {
            this.showError(clientAddressSaveRes.data);
          } else {
            this.saveAddressAndCityInfoIfNeeded();
          }
        })
    },

    saveAddressAndCityInfoIfNeeded() {
      const addressAndCityInfo = {};
      let needToStoreData = false;
      for (const [key, value] of Object.entries(this.addressTimeData)) {
        if (value) {
          addressAndCityInfo[key] = value;
          needToStoreData = true;
        }
      }
      if (needToStoreData) {
        this.loading = true;
        DataSource.getDataTableInfo(DataTables.PERSONAL_DETAILS, LoanScopeDataHolder.getClientId())
          .then(personalDetailsRes => {
            if (personalDetailsRes.errorOccurred) {
              this.showError(personalDetailsRes.data)
            } else {
              if (EzUtils.isNotEmpty(personalDetailsRes.data)) {
                DataSource.updateDataTableEntry(DataTables.PERSONAL_DETAILS,
                  LoanScopeDataHolder.getClientId(),
                  addressAndCityInfo
                )
                  .then(res => {
                    this.loading = false;
                    if (res.errorOccurred) {
                      this.showError(res.data)
                    } else {
                      this.completeCurrentTaskAndGetNextTask();
                    }
                  })
              } else {
                DataSource.addDataTableEntry(
                  DataTables.PERSONAL_DETAILS,
                  LoanScopeDataHolder.getClientId(),
                  addressAndCityInfo
                )
                  .then(res => {
                    this.loading = false;
                    if (res.errorOccurred) {
                      this.showError(res.data)
                    } else {
                      this.completeCurrentTaskAndGetNextTask();
                    }
                  })
              }
            }
          })
      } else {
        this.completeCurrentTaskAndGetNextTask();
      }
    },

    completeCurrentTaskAndGetNextTask() {
      this.loading = true;
      LoanTasksActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data);
          }
        });
    },

    filterState() {
      this.stateList = [];
      let states = [];
      this.stateProvinceIdOptions.forEach(code => {
        states.push(code.name);
      });
      states.sort();
      this.stateList = states;
    },

    fetchInitialData() {
      this.showRefreshItem = false;
      this.loading = true;
      DataSource.getAddressTemplates()
        .then(addressTemplateRes => {
          this.loading = false;
          if (addressTemplateRes.errorOccurred) {
            this.showError(addressTemplateRes.data);
            this.showRefreshItem = true;
          } else {
            this.permanentAddressTypeId = DataTableUtils.getOptionId(
              addressTemplateRes.data[AddressResponse.ADDRESS_TYPE_ID_OPTIONS],
              PERMANENT_ADDRESS_TYPE
            );
            this.currentAddressTypeId = DataTableUtils.getOptionId(
              addressTemplateRes.data[AddressResponse.ADDRESS_TYPE_ID_OPTIONS],
              HOME_ADDRESS_TYPE
            );
            this.countryId = DataTableUtils.getOptionId(
              addressTemplateRes.data[AddressResponse.COUNTRY_ID_OPTIONS],
              INDIA
            );
            this.stateProvinceIdOptions = addressTemplateRes.data[AddressResponse.STATE_PROVINCE_ID_OPTIONS];
            this.filterState();
            this.fetchLeadOrClientAddress();
          }
        })
    },

    fetchLeadOrClientAddress() {
      this.loading = true;
      if (EzUtils.isValidId(LoanScopeDataHolder.getLeadId())) {
        DataSource.getLeadDetails(LoanScopeDataHolder.getLeadId())
          .then(leadDetailsRes => {
            this.loading = false;
            if (leadDetailsRes.errorOccurred) {
              this.showError(leadDetailsRes.data);
              this.showRefreshItem = true;
            } else {
              const leadDetails = leadDetailsRes.data;
              const leadDetailsData = leadDetails && leadDetails.data
                ? EzUtils.convertToJSONObjectIfString(leadDetails.data)
                : {};
              if (leadDetailsData
                && leadDetailsData.addresses
                && leadDetailsData.addresses.length > 0
              ) {
                this.showUI = true;
                const addresses = leadDetailsData.addresses;
                let address = addresses[addresses.length - 1];
                addresses.forEach(addressInLead => {
                  if (addressInLead
                    && EzUtils.areEqualString("PERMANENT", addressInLead.type, true)
                  ) {
                    address = addressInLead;
                    this.inputEntered(AddressResponse.STATE_PROVINCE_ID, -1);
                    this.inputEntered(AddressResponse.ADDRESS_TYPE_ID, this.permanentAddressTypeId);
                    this.inputEntered(AddressResponse.COUNTRY_ID, this.countryId);
                    this.inputEntered(AddressResponse.STREET, address.street);
                    this.inputEntered(AddressResponse.ADDRESS_LINE1, address.address_line_1);
                    this.inputEntered(AddressResponse.ADDRESS_LINE2, address.address_line_2);
                    this.inputEntered(AddressResponse.ADDRESS_LINE3, address.address_line_3);
                    this.inputEntered(AddressResponse.CITY, address.city);
                    this.postalEntered(address.pincode);
                  } else {
                    this.fetchClientAddress();
                  }
                });
              } else {
                this.fetchClientAddress();
              }
            }
          })
      } else {
        this.fetchClientAddress();
      }
    },

    fetchClientAddress() {
      this.loading = true;
      DataSource.getClientAddress(
        LoanScopeDataHolder.getClientId(),
        new Array(true),
        this.currentAddressTypeId
      )
        .then(clientAddressRes => {
          this.loading = false;
          if (clientAddressRes.errorOccurred) {
            this.showError(clientAddressRes.data);
            this.showRefreshItem = true;
          } else {
            this.showUI = true;
            this.inputEntered(AddressResponse.STATE_PROVINCE_ID, -1);
            this.inputEntered(AddressResponse.ADDRESS_TYPE_ID, this.permanentAddressTypeId);
            this.inputEntered(AddressResponse.COUNTRY_ID, this.countryId);

            const addresses = clientAddressRes.data;
            if (EzUtils.isNotEmpty(addresses)) {
              this.currentAddress = addresses[addresses.length - 1];
              this.showSameAsCurrentAddressCheckbox = true;
              this.sameAsCurrentAddressDefaultSelection = true;
            }
          }
        })
    }
  },

  mounted: function () {
    this.fetchInitialData();
  },

  created: function () {
    this.dynamicFields = DynamicFieldUtils.getRequiredDynamicFieldsData();
  },

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.PERMANENT_ADDRESS];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
        ? LoanScopeDataHolder.getCurrentLoanTask().name
        : "";
    },

    dropdownConfig() {
      return DefaultResourceConfig.DROP_DOWN;
    },

    addressHeading() {
      const addressOwner = this.isAgent ? "customer's" : "your";
      return `Please enter ${addressOwner} Permanent address`;
    },

    isAgent() {
      return PrefManager.doesUserHasRole(RolesConstants.AGENT);
    },

    checkBoxConfig() {
      return DefaultResourceConfig.CHECK_BOX;
    }
  }
}
</script>

<style scoped src="../../assets/style/base.css"></style>
-->